module.exports = __webpack_public_path__ + "img/3d_design2.259ac769.png";